<template>
  <div class="contents mst_syounin_group_search">
    <h2>承認グループ検索</h2>

    

      <div class="search">
        <h3>検索項目</h3>
        <div class="item-container">
          <div class="col-item name">
            <b>承認グループ名</b>
              <input-text type="text" v-model="syouninGroupStore.item.group_name"></input-text>
            </div>
        </div>

        <div class="btn-container">
          <button type="button" class="btn clear" @click="clear">クリア</button>
          <button type="button" class="btn primary" @click="search"><i class="fa-solid fa-magnifying-glass"></i>検索</button>
        </div>
      </div>

      <div class="col-item btn-container">
        <router-link :to="{ name: RouterConst.MST_SYOUNIN_GROUP_CREATE }" class="btn-link create"><i class="fa-solid fa-plus"></i> 新規追加
        </router-link>
      </div>

      <div class="container">
      <loading v-if="isLoading" :message="'データ読み込み中...'"></loading>

      <div class="search-result" v-if="syouninGroupList.length">
        <table class="group-list">
          <thead>
            <tr>
              <th class="name">承認グループ名</th>
              <th class="type">承認種別</th>
              <th class="syounin-users">[承認順序] 承認者</th>
              <!-- <th class="group-users">所属ユーザー [社員コード]</th>  -- MEDICA_AS-1206 対応 -->
              <th class="control">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in syouninGroupList">
              <td class="name">
                <router-link
                  :to="{ name: RouterConst.MST_SYOUNIN_GROUP_EDIT, params: { id: row.mst_syounin_group_id } }">{{
                    row.group_name }}</router-link>
              </td>
              <td class="type">{{ syouninGroupOptions ? getSyouninGroupOptionsLabel(syouninGroupOptions?.syounin_types,
                row.syounin_type) : '-' }}
              </td>
              <td class="syounin-users">
                <ul>
                  <li v-for="su in row.syounin_users">[{{ su.is_syounin ? su.syounin_order : '確認者' }}] {{ su.staff_name }}</li>
                </ul>
              </td>
              <!-- <td class="group-users">
                <ul>
                  <li v-for="gu in row.group_users">{{ gu.staff_name }} <span v-if="gu.staff_code">[{{ gu.staff_code
                  }}]</span></li>
                </ul>
              </td> -- MEDICA_AS-1206 対応 -->

              <td class="control">
                <div class="flex">
                  <button type="button" class="btn danger"
                    v-on:click="deleteSelectGroup(row.mst_syounin_group_id)">削除</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="button-container">
      <p class="prev-page">
        <router-link :to="{
          name: RouterConst.MST_MENU,
        }">メニューに戻る
        </router-link>
      </p>
    </div>

  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted, ref } from 'vue';
import { RouterConst } from '@/const/Router';
import { useRouter } from "vue-router";
import { useSyouninGroupOptions } from '@/composable/master/syounin_group/syounin_group_options';
import { useSyouninGroup } from '@/composable/master/syounin_group/syounin_group';
import { useSyouninGroupStore } from '@/store/syounin-group';
import { MstSyouninGroupReq } from "@/types/SyouninGroup";

export default defineComponent({
  setup() {
    // 初期化
    const router = useRouter();
    const { getAllSyouninGroupOptions, syouninGroupOptions, getSyouninGroupOptionsLabel } = useSyouninGroupOptions()
    const isLoading = ref(false)

    const { deleteSyouninGroup, getSyouninGroupsList, syouninGroupList } = useSyouninGroup()

    const syouninGroupStore = useSyouninGroupStore();

    onMounted(async () => {
      isLoading.value = true
      await getAllSyouninGroupOptions()

      // 検索条件をリクエストに格納する
      let req: MstSyouninGroupReq = {
        group_name : syouninGroupStore.item.group_name
      }
      await getSyouninGroupsList(req)
      isLoading.value = false
    })

    // 承認グループを削除します
    const deleteSelectGroup = async (id: number) => {
      if (!syouninGroupList.value) {
        return
      }

      if (await deleteSyouninGroup(id)) {
        isLoading.value = true

        // 検索条件をリクエストに格納する
        let req: MstSyouninGroupReq = {
          group_name : syouninGroupStore.item.group_name
        }
        await getSyouninGroupsList(req)
        isLoading.value = false
      }
    };

    // クリアボタンクリック
    const clear = async () => {
      // 検索条件をclear
      await syouninGroupStore.clear()
      syouninGroupList.value = [];
    }

    // 検索ボタンクリック
    const search = async () => {
      isLoading.value = true;
      // 検索条件を格納
      await syouninGroupStore.setItem(syouninGroupStore.item);

      // 検索条件をリクエストに格納する
      let req: MstSyouninGroupReq = {
        group_name : syouninGroupStore.item.group_name
      };
      await getSyouninGroupsList(req);
      isLoading.value = false;
    };

    return {
      /** 一般 */
      RouterConst,
      router,
      isLoading,
      getSyouninGroupOptionsLabel,
      syouninGroupOptions,

      /** 承認グループ関係 */
      syouninGroupList,
      deleteSelectGroup,
      deleteSyouninGroup,

      /** 検索関連 */
      clear,
      search,
      syouninGroupStore,
    }
  },
  components: {

  }
})
</script>

<style lang="scss" scoped>@import "@scss/components/syounin_group_search.scss";</style>